<header class="header-channel">
    <app-user-chip [user]="user" (click)="this.dialogService.showUserDialog(user, undefined)" (error)="onImageError($event)"></app-user-chip>
</header>
